/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { SITEDTL_URL } from '../constant';
import { fetchWithAuth } from '../helper/makeAjaxRequest';

const [PENDING, FULLFILLED, REJECTED] = ['pending', 'fulfilled', 'rejected'];
export const initialState = {
  data: [],
  loading: false,
  error: false,
  status: false
};

// thunk middleware
export const fetchClinicalInvestigatorLov = createAsyncThunk(
  'fetchClinicalInvestigatorLov',
  async ({ userType, viewType }, { rejectWithValue }) => {
    try {
      return await fetchWithAuth(
        `${SITEDTL_URL}/clinicalinvestigators/${userType}/${viewType}`
      );
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const clinicalInvestigatorLovSlice = createSlice({
  name: fetchClinicalInvestigatorLov,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchClinicalInvestigatorLov.pending, (state) => {
      state.loading = true;
      state.error = false;
      state.data = [];
      state.status = PENDING;
    });
    builder.addCase(fetchClinicalInvestigatorLov.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.status = FULLFILLED;
    });
    builder.addCase(fetchClinicalInvestigatorLov.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.status = REJECTED;
    });
  }
});

// selectors
export const clinicalInvestigatorLovSelector = (state) =>
  state?.clinicalInvestigatorLov?.data;
export const clinicalInvestigatorLovIsLoadedSelector = (state) =>
  state?.clinicalInvestigatorLov?.status === FULLFILLED;

export default clinicalInvestigatorLovSlice.reducer;
